/**
 * @param element {HTMLElement}
 * @return {void}
 */
module.exports = function scrollElementIntoView(element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
}
